<template>
  <PopDialog
    title="영역 선택"
    :visible="props.visible"
    :cancelCallback="onCancelClick"
    :showCancel="false"
    :okText="'닫기'"
    :okCallback="onCancelClick"
  >
    <div class="zone-select-list">
      <div
        v-for="zone in zones"
        :key="zone._id"
        class="zone-select-item"
        :class="{ 'zone-select-item-active': zone._id === currentZoneId }"
        @click="onZoneSelect(zone._id)"
      >
        <div class="zone-select-icon">
          <i 
            :class="zone.isOwner ? 'fa-regular fa-house' : 'fa-solid fa-house-user'"
          ></i>
        </div>
        <div class="zone-select-content">
          <div class="zone-select-name">
            {{ zone.name }}
            <span v-if="!zone.isOwner" class="zone-select-share">(Share)</span>
          </div>
        </div>
        <div class="zone-select-check" v-if="zone._id === currentZoneId">
          <i class="fa-solid fa-check"></i>
        </div>
      </div>
    </div>
  </PopDialog>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import PopDialog from '@/common/components/popup/PopDialog.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  zones: {
    type: Array,
    default: () => [],
  },
  currentZoneId: {
    type: String,
    default: '',
  },
  onSelect: {
    type: Function,
    default: null,
  },
});

const emit = defineEmits(['select', 'close']);

const onZoneSelect = (zoneId) => {
  if (props.onSelect) {
    props.onSelect(zoneId);
  }
  emit('select', zoneId);
  emit('close');
};

const onCancelClick = () => {
  emit('close');
};
</script>

<style scoped>
.zone-select-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 400px;
  overflow-y: auto;
}

.zone-select-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;
}

.zone-select-item:hover {
  border-color: #0d6efd;
  background-color: #f0f7ff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.15);
}

.zone-select-item-active {
  border-color: #0d6efd;
  background-color: #e7f3ff;
}

.zone-select-icon {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  flex-shrink: 0;
}

.zone-select-icon i {
  font-size: 1.25rem;
  color: #0d6efd;
}

.zone-select-item-active .zone-select-icon {
  background-color: #0d6efd;
}

.zone-select-item-active .zone-select-icon i {
  color: #ffffff;
}

.zone-select-content {
  flex: 1;
  min-width: 0;
}

.zone-select-name {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
}

.zone-select-share {
  font-size: 0.875rem;
  font-weight: 400;
  color: #6c757d;
  margin-left: 0.25rem;
}

.zone-select-check {
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  border-radius: 50%;
  flex-shrink: 0;
}

.zone-select-check i {
  font-size: 0.75rem;
  color: #ffffff;
}
</style>
